import Cookie from 'js-cookie';

export const removeCookieEverywhere = (name) => {
  const domainParts = window.location.hostname.split('.');
  const paths = ['/', window.location.pathname];

  for (let i = 0; i < domainParts.length - 1; i++) {
    const domain = `.${domainParts.slice(i).join('.')}`;
    paths.forEach((path) => {
      Cookie.remove(name, { path, domain });
    });
  }

  paths.forEach((path) => {
    Cookie.remove(name, { path });
  });
};
